<template>
   <b-container>
      <b-form v-if="hasPayrollAccess" @submit.prevent="submitNewEmployee">
         <div class="d-flex align-items-center justify-content-between">
            <h5
               style="
                  font-weight: 600;
                  margin-bottom: 10px;
                  margin-left: 0;
                  color: black;
                  font-size: 1rem;
               "
            >
               New Employee
            </h5>
         </div>

         <b-row style="font-size: 13px" class="font-weight-normal">
            <b-col cols="3" style="padding-right: 0">
               <b-form-group label-for="input-new-full-name" invalid-feedback="Required">
                  <template #label>
                     Full Name <label style="color: red; margin-bottom: 0">*</label></template
                  >
                  <b-form-input
                     id="input-new-full-name"
                     style="font-size: 13px"
                     class="font-weight-normal"
                     v-model="newEmployee.fullname"
                     :state="
                        $v.newEmployee.fullname.$dirty && $v.newEmployee.fullname.$invalid
                           ? false
                           : null
                     "
                     ref="newEmployeeName"
                     :disabled="newEmployee.saving"
                  ></b-form-input>
               </b-form-group>
            </b-col>

            <b-col cols="3" style="padding-right: 0">
               <b-form-group label-for="input-new-location" invalid-feedback="Required">
                  <template #label>
                     Location <label style="color: red; margin-bottom: 0">*</label></template
                  >
                  <b-form-select
                     :id="'input-new-location'"
                     :options="stateOptions"
                     class="font-weight-normal"
                     style="font-size: 13px"
                     v-model="newEmployee.location"
                     :state="
                        $v.newEmployee.location.$dirty && $v.newEmployee.location.$invalid
                           ? false
                           : null
                     "
                     :disabled="newEmployee.saving"
                  >
                     <template #first>
                        <b-form-select-option :value="null" disabled>
                           Please select one
                        </b-form-select-option>
                     </template>
                  </b-form-select>
               </b-form-group>
            </b-col>

            <b-col cols="3" style="padding-right: 0">
               <b-form-group label-for="select-studied-periods" invalid-feedback="Required">
                  <template #label>
                     Study Periods <label style="color: red; margin-bottom: 0">*</label></template
                  >
                  <multi-select
                     id="select-studied-periods"
                     v-model="periodIds"
                     :options="studyPeriodOptions"
                     :disabled="newEmployee.saving"
                     show-select-all
                     :state="$v.periodIds.$dirty && $v.periodIds.$invalid ? false : null"
                  />
               </b-form-group>
            </b-col>
         </b-row>

         <b-row style="font-size: 13px" class="font-weight-normal">
            <b-col cols="3" style="padding-right: 0">
               <b-form-group label="Employee ID" label-for="input-new-employee-id">
                  <b-form-input
                     style="font-size: 13px"
                     id="input-new-employee-id"
                     class="font-weight-normal"
                     v-model="newEmployee.ident"
                     :disabled="newEmployee.saving"
                  ></b-form-input>
               </b-form-group>
            </b-col>

            <b-col cols="3" style="padding-right: 0">
               <b-form-group label="Job Title" label-for="input-new-job-title">
                  <b-form-input
                     style="font-size: 13px"
                     id="input-new-job-title"
                     class="font-weight-normal"
                     v-model="newEmployee.title"
                     list="datalist-titles"
                     autocomplete="off"
                     :disabled="newEmployee.saving"
                  ></b-form-input>
               </b-form-group>
            </b-col>

            <b-col cols="3" style="padding-right: 0">
               <b-form-group label="Department" label-for="input-new-department">
                  <b-form-input
                     style="font-size: 13px"
                     id="input-new-department"
                     class="font-weight-normal"
                     v-model="newEmployee.department"
                     list="datalist-departments"
                     autocomplete="off"
                     :disabled="newEmployee.saving"
                  ></b-form-input>
               </b-form-group>
            </b-col>

            <b-col cols="3" style="padding-right: 0">
               <b-form-group label="Company Officer" label-for="select-new-officer">
                  <template #label>Company Officer </template>
                  <b-form-select
                     style="font-size: 13px"
                     id="select-new-officer"
                     class="font-weight-normal"
                     :options="[
                        {value: true, text: 'Yes'},
                        {value: false, text: 'No'},
                     ]"
                     v-model="newEmployee.officer"
                     :disabled="newEmployee.saving"
                  >
                  </b-form-select>
               </b-form-group>
            </b-col>
         </b-row>

         <b-form-row>
            <b-col class="d-flex justify-content-start">
               <b-button
                  variant="primary"
                  style="font-size: 12px; padding: 5px 20px !important; height: 30px !important"
                  id="btn-add-employee"
                  class="d-flex align-items-center mb-4 font-weight-normal"
                  type="submit"
                  :disabled="saveDisabled"
               >
                  <b-spinner small v-if="newEmployee.saving" class="mr-1"></b-spinner>
                  Add Employee
               </b-button>
            </b-col>
         </b-form-row>
      </b-form>

      <label
         style="
            font-weight: 600;
            margin-bottom: 10px;
            margin-left: 0;
            color: black;
            font-size: 1rem;
         "
         >Employees ({{ filteredEmployees.length }})</label
      >

      <b-tabs content-class="mt-3" v-model="activeTabIndex">
         <b-tab title="All"></b-tab>
         <b-tab
            v-for="period in studyPeriodOptions"
            :key="period.value"
            :title="period.text"
         ></b-tab>
      </b-tabs>

      <b-table
         id="table-edit-employees"
         :fields="fields"
         sort-by="fullname"
         :items="filteredEmployees"
         responsive
         sticky-header="300px"
         style="font-size: 13px"
      >
         <template #cell(fullname)="data">
            <div class="d-flex align-items-center">
               <button
                  class="btn btn-link delete-file"
                  style="padding: 0; margin-right: 10px"
                  type="button"
                  @click="deleteEmployee(data.item)"
               >
                  <b-icon-trash style="color: grey"></b-icon-trash>
               </button>
               {{ data.value }}
            </div>
         </template>

         <template #cell(periods)="data">
            <div class="periods-cell">
               {{ employeePeriodsText(data.item.id) }}
            </div>
         </template>

         <template #cell(payroll)="data">
            <div class="d-flex align-items-center">
               <tcp-input-group prepend="$">
                  <b-form-input
                     :id="`employee-payroll-edit-${data.item.id}`"
                     class="edit-payroll-input"
                     :value="formatCurrencyForDisplay(payrollForEmployee(data.item.id))"
                     @blur="(event) => onEditPayroll(data.item, event.target.value)"
                     :disabled="!hasPayrollAccess && !isAssignedToMe(data.item)"
                  >
                  </b-form-input>
               </tcp-input-group>
            </div>
         </template>
      </b-table>

      <datalist id="datalist-titles">
         <option v-for="title in companyTitles" :key="title">
            {{ title }}
         </option>
      </datalist>

      <datalist id="datalist-departments">
         <option v-for="department in companyDepartments" :key="department">
            {{ department }}
         </option>
      </datalist>
   </b-container>
</template>

<script>
import {mapGetters} from 'vuex';
import {required} from 'vuelidate/lib/validators';

import {Employee} from '@/store/models/employee';
import {formatCurrency as formatCurrencyUtil} from '@/helpers/utils';
import {clientUserSuggestions, expensePermissionsMixin} from '@/mixins';
import {getManualVendorId} from '@/store/utils/expense-data-identity';

export default {
   name: 'EmployeesManualFlow',

   mixins: [clientUserSuggestions, expensePermissionsMixin],

   data() {
      return {
         newEmployee: new Employee(),
         payroll: null,
         periodIds: [],
         payrollSaving: false,
         activeTabIndex: 0,
      };
   },

   computed: {
      ...mapGetters({
         usStates: 'usStates',
         currentCompany: 'companies/currentCompany',
         employees: 'employees/manualVendors',
         baseSupportedPeriodIds: 'employees/baseSupportedPeriodIds',
         studyPeriodMap: 'companies/studyPeriodMap',
         adHocData: 'employees/adHocData',
         profile: 'profile',
      }),

      // A new employee has no existing assignment yet, so this must not be restricted to
      // periods an SME already has an assigned employee in (see baseSupportedPeriodIds) --
      // otherwise an SME with no prior assignments could never add a first employee, unlike
      // a Customer. The period tabs below reuse the same list so they stay in sync with
      // what's offered in the "Study Periods" picker.
      studyPeriodOptions() {
         return this.baseSupportedPeriodIds
            .map((periodId) => this.studyPeriodMap[periodId])
            .filter(Boolean)
            .sort((a, b) => a.startDate - b.startDate)
            .map((period) => ({value: period.id, text: period.label}));
      },

      activePeriodId() {
         return this.activeTabIndex === 0
            ? null
            : this.studyPeriodOptions[this.activeTabIndex - 1]?.value ?? null;
      },

      filteredEmployees() {
         if (this.activePeriodId === null) {
            return this.employees;
         }
         const idsForPeriod = new Set(
            (this.adHocData[this.activePeriodId] || [])
               // Dummy placeholder rows (id === null) are seeded for every vendor on every
               // supported period, so the entry table always has a blank row -- they don't
               // signal real period membership, so exclude them from the tab filter.
               .filter((entry) => entry.id !== null)
               .map(getManualVendorId)
         );
         return this.employees.filter((employee) => idsForPeriod.has(employee.id));
      },

      companyId() {
         return this.currentCompany?.id ?? this.$companyId;
      },

      fields() {
         const fields = [
            {
               key: 'fullname',
               label: 'Name',
               sortable: false,
               stickyColumn: true,
               tdClass: 'cell-class',
               thClass: 'cell-class',
            },
            {
               key: 'location',
               label: 'U.S. State',
               sortable: false,
               tdClass: 'cell-class',
               thClass: 'cell-class location-class',
            },
            {
               key: 'ident',
               label: 'Employee ID',
               sortable: false,
               tdClass: 'cell-class',
               thClass: 'cell-class',
            },
         ];

         if (this.activeTabIndex === 0) {
            fields.push(
               {
                  key: 'title',
                  label: 'Job Title',
                  sortable: false,
                  tdClass: 'cell-class',
                  thClass: 'cell-class',
               },
               {key: 'department', sortable: false, tdClass: 'cell-class', thClass: 'cell-class'},
               {
                  key: 'officer',
                  sortable: false,
                  formatter: (x) => (x ? 'Yes' : 'No'),
                  sortByFormatted: true,
                  tdClass: 'cell-class',
                  thClass: 'cell-class',
               },
               {
                  key: 'periods',
                  label: 'Periods',
                  sortable: false,
                  tdClass: 'cell-class periods-cell',
                  thClass: 'cell-class periods-cell',
               }
            );
         } else {
            fields.push(
               {
                  key: 'title',
                  label: 'Job Title',
                  sortable: false,
                  tdClass: 'cell-class',
                  thClass: 'cell-class',
               },
               {key: 'department', sortable: false, tdClass: 'cell-class', thClass: 'cell-class'},
               {
                  key: 'officer',
                  sortable: false,
                  formatter: (x) => (x ? 'Yes' : 'No'),
                  sortByFormatted: true,
                  tdClass: 'cell-class',
                  thClass: 'cell-class',
               }
            );
         }

         if (this.hasPayrollAccess && this.activePeriodId !== null) {
            fields.push({
               key: 'payroll',
               label: 'Employee Taxable Wages',
               sortable: false,
               sortByFormatted: true,
               tdClass: 'cell-class',
               thClass: 'cell-class payroll-cell-class',
            });
         }

         return fields;
      },

      stateOptions() {
         return Object.entries(this.usStates).map(([key, value]) => ({text: value, value: key}));
      },

      saveDisabled() {
         return this.newEmployee.saving || this.$v.$invalid;
      },
   },

   methods: {
      resetNewEmployee() {
         this.newEmployee = new Employee();
         this.payroll = null;
         this.periodIds = [];
         this.$v.$reset();
      },

      isAssignedToMe(employee) {
         return employee.assigneeId === this.profile.id;
      },

      formatCurrencyForDisplay(value) {
         if (value === null || value === undefined || value === '') {
            return '';
         }
         return formatCurrencyUtil(value / 100);
      },

      sanitizeCurrencyInput(value) {
         if (value === null || value === undefined) return null;
         const str = String(value)
            .replace(/[^\d.-]/g, '')
            .trim();
         if (str === '' || str === '.' || str === '-' || str === '-.') return null;
         const num = Number(str);
         return Number.isFinite(num) ? Math.round(num * 100) : null;
      },

      formatCurrency() {
         if (this.payroll === '' || this.payroll === null) return;
         const number = parseFloat(this.payroll.toString().replace(/,/g, ''));
         if (!Number.isNaN(number)) {
            this.payroll = number.toLocaleString('en-US', {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2,
            });
         }
      },

      unformatCurrency() {
         if (this.payroll) {
            this.payroll = this.payroll.replace(/,/g, '');
         }
      },

      async loadEmployees() {
         if (!this.companyId) return;
         // Two dispatches, not Promise.all: loadData's initializeAdHocDataAction reads
         // the manualVendors state that loadAllAssignmentsByCompanyId populates, so the
         // roster must be refreshed first.
         this.$emit('showSpinner', true);
         try {
            await this.$store.dispatch('employees/loadAllAssignmentsByCompanyId', {
               companyId: this.companyId,
            });
            await this.$store.dispatch('employees/loadData', {companyId: this.companyId});
         } finally {
            this.$emit('showSpinner', false);
         }
      },

      async submitNewEmployee() {
         this.$v.$touch();
         if (this.$v.$invalid || this.waiting) {
            return;
         }

         const payload = {
            companyId: this.companyId,
            fullname: this.newEmployee.fullname,
            ident: this.newEmployee.ident,
            location: this.newEmployee.location,
            title: this.newEmployee.title,
            department: this.newEmployee.department,
            officer: this.newEmployee.officer,
         };

         // Always send periodIds (even empty) so an intentionally-empty selection means
         // "no periods yet" -- omitting the field entirely falls back to "all periods" in
         // buildManualSummaryPeriodsPayload, which is meant for vendor types with no period
         // picker at all, not for an employee whose periods just weren't selected.
         payload.periodIds = this.periodIds;

         if (this.hasPayrollAccess && this.activePeriodId !== null && this.payroll !== null) {
            this.unformatCurrency();
            payload.payroll = this.sanitizeCurrencyInput(this.payroll);
         }

         try {
            this.newEmployee.startSave();
            await this.blockingRequest('employees/createManualVendor', payload);
            await this.loadSuggestions(true);
            await this.loadEmployees();
            this.resetNewEmployee();
            this.$nextTick(() => this.$refs.newEmployeeName?.focus?.());
         } catch (err) {
            const msg = err?.response?.data?.errors?.[0]?.detail || '';
            const errCode = err?.response?.data?.errors?.[0]?.code;
            if (msg.includes('UniqueViolationError')) {
               this.$store.commit('showAlert', {
                  msg: 'An employee with that Employee ID already exists.',
                  seconds: 5,
               });
            } else if (![120, 121].includes(errCode)) {
               this.$store.commit('showAlert', {
                  response: err.response,
                  fallbackMsg: 'Submission failed',
                  seconds: 5,
               });
            }
         } finally {
            this.newEmployee.endSave();
         }
      },

      findSummaryForEmployee(employeeId) {
         return (this.adHocData[this.activePeriodId] || []).find(
            (entry) => getManualVendorId(entry) === employeeId
         );
      },

      payrollForEmployee(employeeId) {
         const summary = this.findSummaryForEmployee(employeeId);
         return summary ? summary.totalDebit : null;
      },

      employeePeriodsText(employeeId) {
         const periodIds = new Set();
         Object.keys(this.adHocData || {}).forEach((periodId) => {
            if (
               (this.adHocData[periodId] || []).some(
                  (entry) => entry.id !== null && getManualVendorId(entry) === employeeId
               )
            ) {
               periodIds.add(periodId);
            }
         });

         const periods = [...periodIds]
            .map((periodId) => this.studyPeriodMap[periodId])
            .filter(Boolean)
            .slice()
            .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
            .map((period) => period.label || period.period || '');

         return periods.length ? periods.join(', ') : 'None';
      },

      async onEditPayroll(employee, value) {
         const summary = this.findSummaryForEmployee(employee.id);
         if (!summary) return;

         const netAmount = this.sanitizeCurrencyInput(value);

         this.payrollSaving = true;
         try {
            await this.$store.dispatch('employees/saveNetAmount', {
               companyId: this.companyId,
               summary,
               netAmount,
            });
         } catch {
            // failure alert is already shown by saveNetAmount
         } finally {
            this.payrollSaving = false;
         }
      },

      async deleteEmployee(employee) {
         const proceed = await this.$bvModal.msgBoxConfirm(
            `Are you sure you want to delete "${employee.fullname}" and any associated data?`,
            {
               id: 'modal-delete-employee',
               title: 'Delete this employee?',
               centered: true,
               buttonSize: 'sm',
               contentClass: 'delete-employee-modal-content',
               headerClass: 'delete-employee-modal-header',
               footerClass: 'delete-employee-modal-footer',
            }
         );
         if (!proceed) return;

         await this.blockingRequest('employees/deleteManualVendor', {
            vendorId: employee.id,
            force: true,
            companyId: this.companyId,
         });
      },
   },

   validations() {
      return {
         newEmployee: {
            fullname: {required},
            location: {required},
         },
         periodIds: {required},
      };
   },

   watch: {
      periodId: {
         immediate: true,
         async handler() {
            await this.loadEmployees();
         },
      },
   },

   async created() {
      await this.loadSuggestions();
      await this.loadEmployees();
      this.resetNewEmployee();
   },
};
</script>

<style scoped lang="scss">
.cell-class {
   font-size: 12px;
}

.payroll-cell-class {
   font-size: 12px;
   min-width: 130px !important;
}

.location-class {
   min-width: 100px;
}

.periods-cell {
   white-space: normal;
}

.edit-payroll-input {
   font-size: 0.75rem;
   min-width: 7.5rem;
}

.currency-input-wrapper {
   position: relative;
   display: inline-block;
   width: 100%;
}

.currency-symbol {
   position: absolute;
   top: 50%;
   left: 10px;
   transform: translateY(-50%);
   color: #6c757d;
   font-weight: 500;
}

.currency-input {
   padding-left: 25px;
   font-weight: 600;
   font-size: 12px;
   padding-top: 0;
   padding-bottom: 0;
   height: 34px;
}
</style>
